import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import styles from "./CommunicationCompletionButton.module.css";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import { ASSEMBLY_STATE } from "src/stores/assemblies/AssemblyStore";

const CommunicationCompletionButtonBase = () => {
    const { t } = useTranslation();
    const { assemblyStore, communicationStore } = useContext(RootStoreContext);
    const { updateAssemblyState } = assemblyStore;
    const { loadAssemblyHistory } = communicationStore;
    const isCompleted = assemblyStore.currentAssembly?.state === ASSEMBLY_STATE.CLOSED;
    const assemblyId = assemblyStore.currentAssembly?.id;

    const onClickCompleteOrReactivate = useCallback(
        () => async (e: React.MouseEvent) => {
            e.preventDefault();
            await updateAssemblyState(isCompleted ? 1 : 9);
            if (assemblyId && assemblyId !== "") {
                loadAssemblyHistory(assemblyId);
            }
        },
        [isCompleted, assemblyId, updateAssemblyState, loadAssemblyHistory]
    );

    return (
        <UI.Button
            className={isCompleted ? styles.ButtonReactivate : styles.ButtonComplete}
            label={
                isCompleted
                    ? t("screens.assemblies.communicationcontent.button_reactivate_assembly")
                    : t("screens.assemblies.communicationcontent.button_complete_assembly")
            }
            onClick={onClickCompleteOrReactivate()}
            variant={isCompleted ? "outline-primary" : undefined}
        />
    );
};

export const CommunicationCompletionButton = Sentry.withProfiler(observer(CommunicationCompletionButtonBase));
